import React from 'react';

const Problem = () => {
  const problems = [
    {
      icon: '🗣️',
      title: 'Language Barriers',
      description: 'Cannot communicate with airline staff, TSA, or gate agents in English'
    },
    {
      icon: '🗺️',
      title: 'Complex Navigation',
      description: 'Confusing terminals, security procedures, and sudden gate changes'
    },
    {
      icon: '📱',
      title: 'Technology Gap',
      description: 'Difficulty with check-in kiosks, apps, and digital boarding passes'
    },
    {
      icon: '✈️',
      title: 'Transit Anxiety',
      description: 'Layovers in unfamiliar international airports create stress'
    }
  ];

  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Elderly Parents Face Real Challenges
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Traveling between US and India shouldn't be this stressful for our parents
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition border border-gray-100"
            >
              <div className="text-5xl mb-4">{problem.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-600 text-white p-8 rounded-2xl max-w-3xl mx-auto text-center shadow-lg">
          <p className="text-2xl font-semibold">
            300,000+ Indians travel between US and India annually
          </p>
          <p className="text-blue-100 mt-2">Many elderly parents traveling alone or with spouse need help</p>
        </div>
      </div>
    </div>
  );
};

export default Problem;